/* 加購專區 Add-on Deals — one-tap add from the cart drawer / cart page */
(function () {
  if (window.__addonDealsBound) return;
  window.__addonDealsBound = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function showError(block, msg) {
    var el = block && block.querySelector('[data-addon-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }

  document.addEventListener('click', async function (event) {
    var btn = event.target.closest('[data-addon-add]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();

    var block = btn.closest('[data-addon-deals]');
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('btn--loading');

    // Ask the theme which sections (drawer / main cart) need re-rendering
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
    );

    try {
      var addRes = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
          sections: sections,
          sections_url: window.location.pathname
        })
      });
      var added = await addRes.json();
      if (!addRes.ok || added.status) {
        throw new Error(added.description || added.message || 'Could not add this item.');
      }

      var cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      cart.sections = added.sections;

      if (window.FoxTheme && FoxTheme.pubsub) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
      } else {
        window.location.reload();
        return;
      }
      document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: added } }));
      document.dispatchEvent(new CustomEvent('addon-deals:added', { detail: { variantId: btn.dataset.variantId } }));
    } catch (err) {
      btn.removeAttribute('aria-busy');
      btn.classList.remove('btn--loading');
      showError(block, err.message);
    }
  });
})();
